import React from 'react';



import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Portfolio   from './Portfolio';
import Contact from './Contact';
import Villas from './Villas';
import TouristAccomondation from './TouristAccomondation';
import './App.css';
import CommercialStores from './CommercialStores';

// Single source of truth for typography — matches CSS variables in styles/variables.css
const FONT_BODY = '"Open Sans", sans-serif';
const FONT_HEADING = '"Playfair Display", serif';

const theme = createTheme({
  palette: {
    // Primary = slate blue, used for buttons & accents (white text on top)
    primary:   { main: '#576a89', contrastText: '#ffffff' },
    // Secondary = light gray-blue, used for the navbar background
    secondary: { main: '#ABBFC4', contrastText: '#576a89' },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: FONT_BODY,
    h1: { fontFamily: FONT_HEADING },
    h2: {
      fontFamily: FONT_HEADING,
      color: '#576a89',
      fontSize: 'clamp(32px, 5vw, 56px)',
      lineHeight: 1.2,
      fontWeight: 600,
      letterSpacing: '0.01em',
    },
    h3: { fontFamily: FONT_HEADING },
    h4: {
      fontFamily: FONT_HEADING,
      fontWeight: 'bold',
      color: '#576a89',
      fontSize: 'calc(1.8rem + 1vw)',
    },
    // Unified body text — elegant light gray, consistent across all pages.
    body1: {
      fontSize: 'clamp(1.05rem, 2vw, 1.25rem)',
      fontWeight: 300,
      lineHeight: 1.7,
      color: 'rgba(0, 0, 0, 0.72)',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio/villas" element={<Villas />} />
            <Route path="/portfolio/tourist_accommodations" element={<TouristAccomondation />} />
            <Route path="/portfolio/commercialstores" element={<CommercialStores />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
